import React from "react";
import styled from "styled-components";
import { Row, Col } from "components/bootstrap";
import {
  THRESHOLD_MODES
} from "license/traffic/types";
import ThresholdTypeRadioSelector from "./ThresholdTypeRadioSelector";
import AbsoluteThresholdForm from "./AbsoluteThresholdForm";
import PercentageThresholdForm from "./PercentageThresholdForm";
const StyledTitle = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacings.sm};
`;
const defaultPercentageConfig = {
  threshold_mode: THRESHOLD_MODES.PERCENTAGE,
  threshold: 90,
  execute_every_seconds: 3600
};
const defaultAbsoluteConfig = {
  threshold: 10737418240,
  // 10 GiB
  threshold_mode: THRESHOLD_MODES.ABSOLUTE,
  execute_every_seconds: 3600
};
const defaultConfig = {
  type: "traffic-v1",
  ...defaultPercentageConfig
};
const EventDefinitionTrafficForm = ({ eventDefinition, onChange, validation }) => {
  const config = { ...defaultConfig, ...eventDefinition.config };
  const handleLicenseTypeChange = (newThresholdMode) => {
    if (newThresholdMode === config.threshold_mode) return;
    const newDefaults = newThresholdMode === THRESHOLD_MODES.PERCENTAGE ? defaultPercentageConfig : defaultAbsoluteConfig;
    onChange("config", {
      ...config,
      ...newDefaults,
      threshold_mode: newThresholdMode
    });
  };
  const handleConfigFieldChange = (name, value) => {
    onChange("config", {
      ...config,
      [name]: value
    });
  };
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(StyledTitle, null, "License Usage Monitoring"), /* @__PURE__ */ React.createElement(
    ThresholdTypeRadioSelector,
    {
      selectedThresholdMode: config.threshold_mode,
      onChange: (newThresholdMode) => handleLicenseTypeChange(newThresholdMode)
    }
  ), config.threshold_mode === THRESHOLD_MODES.PERCENTAGE ? /* @__PURE__ */ React.createElement(
    PercentageThresholdForm,
    {
      validation,
      handleConfigFieldChange,
      config
    }
  ) : /* @__PURE__ */ React.createElement(
    AbsoluteThresholdForm,
    {
      validation,
      handleConfigFieldChange,
      config
    }
  )));
};
EventDefinitionTrafficForm.defaultConfig = defaultConfig;
export default EventDefinitionTrafficForm;
